
/**
 * Module dependencies.
 */

import { Context, createContext, useContext } from 'react';

/**
 * Export `Disclosures` type.
 */

export type Disclosures = {
  [key: string]: boolean
};

/**
 * Export `DisclosureName` type.
 */

export type DisclosureName = string;

/**
 * `Props` type.
 */

type Props = {
  disclosures: Disclosures | null;
  getDisclosureState?: (name: DisclosureName) => boolean;
  onClose?: (name: DisclosureName) => void;
  onCloseAll?: () => void;
  onOpen?: (name: DisclosureName) => void;
  onOpenAndCloseOthers?: (name: DisclosureName) => void;
  onToggle?: (name: DisclosureName) => void;
}

/**
 * Export `FiltersDisclosuresContext` context.
 */

export const FiltersDisclosuresContext: Context<Props> = createContext({
  disclosures: null
});

/**
 * Export `useFiltersDisclosures` hook.
 */

export const useFiltersDisclosures = () => {
  return useContext(FiltersDisclosuresContext);
};
